// extracted by mini-css-extract-plugin
export var container = "_v2-0";
export var table = "_v2-2";
export var tableWrapper = "_v2-1";